<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Agregar o Editar un Producto</h4>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="productForm" (ngSubmit)="productForm.valid && confirm()">
        <div class="modal-body">
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Cantidad</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="quantity"></span>
                </label>
                <div class="col-10 col-md-10 col-sm-8 ">
                    <input type="number" class="form-control" formControlName="quantity"
                        [ngClass]="productForm.controls.quantity.errors ? 'is-invalid' : 'is-valid'">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Código</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="productCode"></span>
                </label>
                <div class="col-10 col-md-10 col-sm-8 input-group">
                    <input type="text" class="form-control" formControlName="productCode"
                        [ngClass]="productForm.controls.productCode.errors ? 'is-invalid' : 'is-valid'" readonly>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" (click)="showAddProduct()"><i
                                class="fa fa-search"></i></button>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Description</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="productDescription"></span>
                </label>
                <div class="col-10 ">
                    <input type="text" class="form-control" formControlName="productDescription"
                        [ngClass]="productForm.controls.productDescription.errors ? 'is-invalid' : 'is-valid'" readonly>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Serial</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="serial"></span>
                </label>
                <div class="col-10 ">
                    <input type="text" class="form-control" formControlName="serial"
                        [ngClass]="productForm.controls.serial.errors ? 'is-invalid' : 'is-valid'">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Precio + ISV</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="price"></span>
                </label>
                <div class="col-10 col-md-10 col-sm-8 ">
                    <input type="number" class="form-control" formControlName="price"
                        [ngClass]="productForm.controls.price.errors ? 'is-invalid' : 'is-valid'">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Descuento</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="discount"></span>
                </label>
                <div class="col-10 col-md-10 col-sm-8 ">
                    <input type="number" class="form-control" formControlName="discount"
                        [ngClass]="productForm.controls.discount.errors ? 'is-invalid' : 'is-valid'">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Impuesto</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="tax"></span>
                </label>
                <div class="col-10 ">
                    <input type="text" class="form-control" formControlName="tax"
                        [ngClass]="productForm.controls.tax.errors ? 'is-invalid' : 'is-valid'" readonly>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
            <button type="submit" class="btn btn-outline-success">Confirmar</button>
        </div>
    </form>
</div><!-- /.modal-content -->